<script>
import imgToastInfo from '@/components/countly/images/icons/notification-toast-informational.svg';
import imgToastSuccessful from '@/components/countly/images/icons/notification-toast-successful.svg';
import imgToastWarning from '@/components/countly/images/icons/notification-toast-warning.svg';
import imgToastDestructive from '@/components/countly/images/icons/notification-toast-destructive.svg';
import countlyVue from '../../compat/vue-core';

export default countlyVue.components.BaseComponent.extend({
  props: {
    id: { default: '', type: [String, Number], required: false },
    text: { default: '' },
    color: { default: 'light-warning', type: String },
    size: { default: 'full', type: String },
    visible: { default: true, type: Boolean },
    closable: { default: true, type: Boolean },
    autoHide: { default: false, type: Boolean },
    buttonText: { default: '', type: String },
  },
  data() {
    return {
      autoHideTimeout: null,
      DEFAULT_STAY_TIME_IN_MS: 7000, // 7 seconds
      isModalVisible: true,
      imgToastInfo,
      imgToastSuccessful,
      imgToastDestructive,
      imgToastWarning,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVisible) {
        this.isModalVisible = newVisible;
      },
    },
    isModalVisible(newVisible) {
      this.$emit('update:visible', newVisible);
    },
  },
  computed: {
    dynamicClasses() {
      return [`cly-vue-notification__alert-box__alert-text--${this.color}`, `cly-vue-notification__alert-box--${this.size}`];
    },
    image() {
      if (this.color === 'dark-informational' || this.color === 'light-informational') {
        return this.imgToastInfo;
      }
      if (this.color === 'light-successful' || this.color === 'dark-successful') {
        return this.imgToastSuccessful;
      }
      if (this.color === 'light-destructive' || this.color === 'dark-destructive') {
        return this.imgToastDestructive;
      }
      if (this.color === 'light-warning' || this.color === 'dark-warning') {
        return this.imgToastWarning;
      }
      return '';
    },
    innerText() {
      if (this.text) {
        return this.text;
      }
      return '';
    },
  },
  methods: {
    closeModal() {
      this.isModalVisible = false;
      this.$emit('close', this.id);
    },
    onButtonClick() {
      this.$emit('button-click');
    },
  },
  mounted() {
    if (this.autoHide) {
      this.autoHideTimeout = setTimeout(this.closeModal, this.DEFAULT_STAY_TIME_IN_MS);
    }
  },
  beforeDestroy() {
    if (this.autoHide && this.autoHideTimeout) {
      clearTimeout(this.autoHideTimeout);
      this.autoHideTimeout = null;
    }
  },
});
</script>
<template>
  <div
    v-if="isModalVisible===true"
    :class="dynamicClasses"
    class="cly-vue-notification__alert-box"
  >
    <div class="bu-is-flex bu-is-justify-content-space-between">
      <div class="bu-is-flex justify-between w-full items-center">
        <div class="flex">
          <img
            :src="image"
            class="alert-image bu-mr-4 bu-my-2 bu-ml-2"
          >
          <slot>
            <span
              class="alert-text"
              style="margin-block:auto"
            >
              {{ innerText }}
            </span>
          </slot>
        </div>
        <div v-if="buttonText" class="w-fit mr-4">
          <button @click="onButtonClick" class="hover:underline cursor-pointer w-fit font-medium text-sm">
            {{ buttonText }}
          </button>
        </div>
      </div>
      <div
        v-if="closable"
        class="bu-mt-2"
      >
        <div
          v-if="size=='full'"
          class="bu-mr-2 bu-ml-2"
          @click="closeModal"
        >
          <slot name="close">
            <i class="el-icon-close" />
          </slot>
        </div>
        <div
          v-else
          class="bu-mr-2 bu-ml-6"
          @click="closeModal"
        >
          <slot name="close">
            <i class="el-icon-close" />
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
